import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // 引入路由配置文件

// 样式全局使用
import "vant/lib/index.css";
import pinia from "./store/index.js";
import VConsole from "vconsole";

// 微信小程序 web-view / iOS Safari：禁止双指缩放，但保留单指滚动和书写。
const preventMultiTouchZoom = (event) => {
  if (event.touches?.length > 1) {
    event.preventDefault();
  }
};

document.addEventListener("touchmove", preventMultiTouchZoom, {
  passive: false,
});
document.addEventListener("gesturestart", (event) => event.preventDefault(), {
  passive: false,
});
document.addEventListener("gesturechange", (event) => event.preventDefault(), {
  passive: false,
});

const debugEnabled =
  process.env.NODE_ENV !== "production" ||
  new URLSearchParams(window.location.search).get("debug") === "1";

if (debugEnabled && !window.__inspectVConsole) {
  window.__inspectVConsole = new VConsole();
}

// function setRem() {
//   const screenWidth = document.documentElement.clientWidth;
//   const scale = screenWidth / 750;

//   // 将 75 改为 86，这样在 375px 屏幕下，结果就是 43px
//   document.documentElement.style.fontSize = 86 * scale + "px";
// }

// // 初始化并监听窗口变化
// setRem();
// window.onresize = setRem;

const app = createApp(App);
app.use(router);
app.use(pinia);
app.mount("#app");
